<template>      
  <tr  :class="isMobile ? 'v-data-table__mobile-table-row' :''">
    <template v-for="(h, idx) in headers" >

      <template v-if="isMobile">
 
        <td v-if="h.type=='actions'" :key="idx" class="d-flex justify-space-around secondary lighten-5"  >
          <template v-if="!!btns">
            <template v-for="(btn, index) in  btns">
              <v-btn
                :icon='!!btn.icon'
                :class='btn.class' 
                :dark='!!btn.dark'
                :small='!!btn.small'
                :outlined='!!btn.outlined'
                :key="`btn${idx}_${index}`"
                @click="$emit(btn.action,item)"

              > 
                <span v-if="btn.text" class="mx-1">{{btn.text}}</span>
                <v-icon  v-if="btn.icon" :small='!!btn.icon.small' class="mx-1">{{btn.icon.icono}}</v-icon>
              </v-btn>
 
            </template>

          </template>
          <template v-else>
            <v-icon large class="" @click="$emit('edit-item',item)">fa fa-pencil</v-icon>
            <v-divider vertical />
            <v-icon large class="" @click="$emit('delete-item',item)">fa fa-trash-o</v-icon>
          </template>
        </td>

        <td v-else class="v-data-table__mobile-row" :key="idx">
          <div class="v-data-table__mobile-row__header">{{h.text}}</div>
          <div v-if="h.type=='checkbox'"><v-simple-checkbox dense :value="item[h.value]?true:false" disabled></v-simple-checkbox></div>
          <div v-else-if="h.type=='date'"  class="v-data-table__mobile-row__cell">{{item[h.value] | DDMMAAAA }}</div>
          <div v-else-if="h.type=='datetime'"  class="v-data-table__mobile-row__cell">{{item[h.value] | DDMMAAAA_HHMM }}</div>
          <div v-else-if="h.type=='icons'" class="v-data-table__mobile-row__cell">
            <template v-for="(icono, idxIcono) in item[h.value]">
              <v-icon :key="idxIcono" class="mx-1">{{icono}}</v-icon>
            </template>
          </div>

          <div v-else-if="h.type=='download'" class="v-data-table__mobile-row__cell">
            <template v-for="(file, idxFile) in item[h.value]">
              <v-icon small :key='`${h.text}${idx}_${idxFile}`' class="mx-1" :color="file.color || 'red' " @click="$emit('download',file.file)" :title="file.file">{{file.icon}}</v-icon>
            </template>
          </div>

          <div v-else-if="h.type=='btns'" class="v-data-table__mobile-row__cell">
            <template v-for="(btn, index) in  h.btns">
              <v-btn
                :icon='!!btn.icon'
                :class='btn.class' 
                :dark='!!btn.dark'
                :small='!!btn.small'
                :outlined='!!btn.outlined'
                :key="`btn${idx}_${index}`"
                @click="$emit(btn.action,item.id)"
              > 
                <span v-if="btn.text" class="mx-1">{{btn.text}}</span>
                <v-icon  v-if="btn.icon" :small='!!btn.icon.small' class="mx-1">{{btn.icon.icono}}</v-icon>
              </v-btn>
            </template>
          </div>

          <div v-else class="v-data-table__mobile-row__cell text-truncate" style="max-width:50vw" :title="item[h.value]">{{item[h.value]}}</div>
        </td>  


      
      </template>

      <template v-else>
        <td v-if="h.type=='text'" :key="idx" :class="['caption','text-truncate', h.class,`text-${h.align}`]" v-text="item[h.value]" :style="[{'max-width':h.width}]" />
        <td v-else-if="h.type=='checkbox'"  :key="idx" :class="['caption', h.class, `text-${h.align}`]"> 
          <v-simple-checkbox dense :value="item[h.value]?true:false" disabled></v-simple-checkbox>
        </td>
        <td v-else-if="h.type=='actions'" :key="idx" :class="[h.class,`text-${h.align}`]" class="px-1">
          <template v-if="!!btns">
            <template v-for="(btn, index) in btns">
              <v-btn
                :icon='!!btn.icon'
                :class='btn.class' 
                :dark='!!btn.dark'
                :small='!!btn.small'
                :outlined='!!btn.outlined'
                :key="`btn${idx}_${index}`"
                @click.prevent="$emit(btn.action,item)"

              > 
                <span v-if="btn.text" class="mx-1">{{btn.text}}</span>
                <v-icon  v-if="btn.icon" :small='!!btn.icon.small' class="mx-1">{{btn.icon.icono}}</v-icon>
              </v-btn>
            </template>
            
          </template>

          <template v-else>
          <v-icon small class="mx-3" @click.stop="$emit('edit-item',item)">fa fa-pencil</v-icon>
          <v-icon small class="mx-3" @click.stop="$emit('delete-item',item)">fa fa-trash-o</v-icon>
          </template>
        </td>

        <td  v-else-if="h.type=='date'" :key="idx" :class="['caption', h.class,`text-${h.align}`]" :style="[{'max-width':h.width}]"> 
          {{ item[h.value] | DDMMAAAA }} 
        </td>

        <td  v-else-if="h.type=='datetime'" :key="idx" :class="['caption','text-no-wrap', h.class,`text-${h.align}`]" :style="[{'max-width':h.width}]"> 
          {{ item[h.value] | DDMMAAAA_HHMM }} 
        </td>

        <td  v-else-if="h.type=='download'" :key="idx" :class="['caption','text-no-wrap', h.class,`text-${h.align}`]" :style="[{'max-width':h.width}]"> 
          <template v-for="(file, idxFile) in item[h.value]">
            <v-icon small :key="idxFile" class="mx-1" :color="file.color || 'red' " @click="$emit('download',file.file)" :title="file.file">{{file.icon}}</v-icon>
          </template>
        </td>   

        <td  v-else-if="h.type=='icons'" :key="idx" :class="['caption', h.class,`text-${h.align}`]" :style="[{'max-width':h.width}]"> 
          <template v-for="(icono, idxIcono) in item[h.value]">
            <v-icon :key="idxIcono" class="mx-1">{{icono}}</v-icon>
          </template>
        </td> 

        <td  v-else-if="h.type=='btns'" :key="idx" :class="['caption', h.class,`text-${h.align}`]" :style="[{'max-width':h.width}]"> 
          <template v-for="(btn, index) in  h.btns">
            <v-btn
              :icon='!!btn.icon'
              :class='btn.class' 
              :dark='!!btn.dark'
              :small='!!btn.small'
              :outlined='!!btn.outlined'
              :key="`btn${idx}_${index}`"
              @click="$emit(btn.action,item.id)"
            > 
              <span v-if="btn.text" class="mx-1">{{btn.text}}</span>
              <v-icon  v-if="btn.icon" :small='!!btn.icon.small' class="mx-1">{{btn.icon.icono}}</v-icon>
            </v-btn>
          </template>
        </td> 

        <td v-else :key="idx">
          {{item[h.value]}}
        </td>              
      </template>
    </template> 
  </tr>

</template>
<script>
/*
type:
  text
  checkbox
  actions
*/
  
  export default {
    name: 'DataGridBody',

    components: {
      
    },
    props:['item','headers','isMobile', 'btns'],

    data: () => ({


    }),
    created: function () {
      //console.log("Componente creado")
      console.log("btns --> ", this.btns)

      console.log("item-->", this.item)
    },
    mounted: function () {
      //console.log("Componente mondado")
    },
    watch: {
    },

    methods: {
    },
    computed: {
    },
  }
</script>

<style scoped>
.border {
  border: 1px #ddd solid !important;
}

</style>
